<template>
  <div class="ka-pc-card">
    <h3 class="ka-pc-card-title">{{ t.keyFiguresTitle }}</h3>

    <div class="ka-pc-stat">
      <div class="ka-pc-stat-label">{{ t.keyFiguresLatest }}</div>
      <div class="ka-pc-stat-row">
        <span class="ka-pc-stat-value">{{ figures.latest.formatted }}</span>
        <span
          v-if="figures.latest.change"
          :class="['ka-pc-badge', figures.latest.changeClass]"
        >{{ figures.latest.change }}</span>
      </div>
    </div>

    <div class="ka-pc-stat">
      <div class="ka-pc-stat-label">{{ t.keyFiguresHighest }}</div>
      <div class="ka-pc-stat-row">
        <span class="ka-pc-stat-value">{{ figures.highest.formatted }}</span>
        <span
          v-if="figures.highest.change"
          :class="['ka-pc-badge', figures.highest.changeClass]"
        >{{ figures.highest.change }}</span>
      </div>
    </div>

    <div class="ka-pc-stat">
      <div class="ka-pc-stat-label">{{ t.keyFiguresLowest }}</div>
      <div class="ka-pc-stat-row">
        <span class="ka-pc-stat-value">{{ figures.lowest.formatted }}</span>
        <span
          v-if="figures.lowest.change"
          :class="['ka-pc-badge', figures.lowest.changeClass]"
        >{{ figures.lowest.change }}</span>
      </div>
    </div>

    <div v-if="figures.intervalChange" class="ka-pc-stat">
      <div class="ka-pc-stat-label">{{ t.intervalChangeLabel }}</div>
      <div class="ka-pc-stat-row">
        <span class="ka-pc-stat-value">{{ figures.intervalChange.formatted }}</span>
        <span
          v-if="figures.intervalChange.change"
          :class="['ka-pc-badge', figures.intervalChange.changeClass]"
        >{{ figures.intervalChange.change }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KeyFiguresCard',
  props: {
    t: { type: Object, required: true },
    figures: { type: Object, required: true }
  }
}
</script>
